var map = {
	"./Messages.jpg": 346,
	"./Messages.png": 142,
	"./book.png": 143,
	"./box.png": 144,
	"./chat.png": 145,
	"./chat_01.png": 347,
	"./chat_02.png": 348,
	"./chat_icon.png": 349,
	"./cloud.png": 146,
	"./dashboard.png": 350,
	"./dot.png": 351,
	"./get_started_bg.png": 352,
	"./john.png": 147,
	"./left_leaf.png": 148,
	"./live_chat.png": 149,
	"./mobile.png": 150,
	"./panguin_img_one.png": 151,
	"./panguin_img_three.png": 152,
	"./panguin_img_two.png": 153,
	"./pluse.png": 154,
	"./richard.png": 155,
	"./right_leaf.png": 156,
	"./skyp_1.png": 353,
	"./skyp_2.png": 354,
	"./support_dashboard.jpg": 355,
	"./triangle.png": 157,
	"./video_icon.png": 356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;